/*
 * decaffeinate suggestions:
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import * as d3 from 'd3';

import Component, {ComponentOptions} from 'molbio/maps/linear/Component';
import {EmptyPlaceholder as EmptyPlaceholderLayout} from 'molbio/maps/linear/LinearLayout';
import Slice from 'molbio/maps/linear/Slice';

export interface EmptyPlaceholderViewOptions extends ComponentOptions {
  slice: Slice;
}

class EmptyPlaceholderView extends Component {
  layout!: EmptyPlaceholderLayout;
  slice!: Slice;

  static initClass(): void {
    this.prototype.className = 'emptyPlaceholder';
    this.prototype.setting = null;
  }

  initialize(options: EmptyPlaceholderViewOptions): void {
    super.initialize(options);
    this.slice = options.slice;
    this.layout = this.model.get('layout').EmptyPlaceholder;
  }

  registerListeners(): void {
    super.registerListeners();
    this.listenTo(this.model.get('sequence')._sequence(), 'change:locked', this.showHandler.bind(this));
    this.listenTo(this.slice, 'change:visibleWidth change:start change:end', this.showHandler.bind(this));
  }

  shouldShow(): boolean {
    const locked = this.model.get('sequence')._sequence().get('locked');
    return !locked && this.slice.start() === 0 && this.slice.end() === 0;
  }

  update(): void {
    if (!this.shouldShow()) {
      return;
    }

    const text = 'Type or paste bases here';
    const root = d3
      .select(this.el)
      .select('.component-wrapper')
      .selectAll('text')
      .data([text])
      .join('text')
      .attr('font-size', 15)
      .attr('text-anchor', 'middle')
      .text(text);
    root.attr('x', this.slice.get('visibleWidth')! / 2).attr('y', this.slice.get('height')! / 2);
  }
}
EmptyPlaceholderView.initClass();

export default EmptyPlaceholderView;
